import * as React from "react";
 
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { auth } from "../redux/slices/authSlice";
import { pricing } from "../redux/slices/pricingSlice";
import amplitude from "../utils/ampli";
import { convertToJsonObject } from "../utils/utils";
import { DownloadIcon } from "lucide-react";
import { setSeverity, setAlertText, setToast } from "../redux/slices/commonComponentSlice";
import { Tooltip } from "@mui/material";


export default function DownloadNeeds({ accountDetails, selectedNeedsMetric,startDate ,endDate}) {
  const dispatch = useDispatch();
  const menuList = {
    "all": "all",
    "needs": "needs",
    "surplus": "surplus", 
  };

  const token = useSelector(auth).token;
  const filteredRedux = useSelector(pricing).filteredPerformance;
  const customFiltersRaw = useSelector(pricing)?.config?.custom_filters;
  const filtersBody = React.useMemo(() => convertToJsonObject(filteredRedux, customFiltersRaw ?? []), [filteredRedux, customFiltersRaw]);


// download_bi_analysis_needs_data?seller_account_id=1&start_date=2024-01-01&end_date=2024-12-11&type=needs

  const fetchFile = async (type) => {
    // const transformedMultiSort = transformToString(sort);
    try {
      const metricType = (type === "turn") ? "turn" : menuList[type] || "needs";
      let response;
      let url = `${process.env.REACT_APP_API_URL}/download_bi_analysis_needs_data?seller_account_id=${accountDetails.account_id}&start_date=${startDate}&end_date=${endDate}&type=${metricType}`;
      response = await axios.post(
        url,
        filtersBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (response.data) {
        dispatch(setToast(true));
        dispatch(setSeverity('info'));
        dispatch(setAlertText(response.data.message));
      }
    } catch (error) {

      const message = error.response.data?.message ? error.response.data.message : "Something went wrong. Please try again!";
      dispatch(setToast(true));
      dispatch(setSeverity("error"));
      dispatch(setAlertText(message));
    }
  };

  return (
  <>
    <Tooltip title="Download your stock performance report grouped by Shape, Carat, Color and Clarity">
        <button
          className="border-[1px] rounded-md bg-transparent font-medium text-[0.74rem] border-[#1E90FF] h-8 text-[#1E90FF] px-2 gap-[0.200rem] flex justify-center items-center"
          onClick={() => {
            amplitude.track({ event_type: `v3_download_open_to_buy_${selectedNeedsMetric}` });
            fetchFile(selectedNeedsMetric);
          }}
        >
          <DownloadIcon className="h-3 w-3" /> Download
        </button>
    </Tooltip>
  </>
);
}
